import React from "react";
import TwoColumnLayout from "../layout/TwoColumnLayout";
import BrandInfoPanel from "./BrandInfoPanel";
import FinishedBrandInfoPanel from "./FinishedBrandInfoPanel";
import ViewDocumentInline from "./ViewDocumentInline";
import { Panel } from "components/panels";
import SectionPanel from "components/panels/SectionPanel/SectionPanel";
import { useLoaderData } from "react-router";
import { useViewport } from "utilities/hookutils";

const App = () => {
  const viewModel = useLoaderData<server.viewmodel.InvoiceV2LandingFrontModel>();
  const viewport = useViewport();
  const isMobile = viewport === "mobile";

  const invoiceSettled = viewModel.status.value === "successInvoiceSettled";
  return <TwoColumnLayout classes={isMobile ? "flex-column" : undefined}>
    <TwoColumnLayout.LeftColumn>
      <ViewDocumentInline secret={viewModel.secret} isMobile={isMobile} />
    </TwoColumnLayout.LeftColumn>
    <TwoColumnLayout.RightColumn style={isMobile ? { width: "100%", minWidth: 0, maxWidth: "none" } : undefined}>
      <SectionPanel.Section>
        {!invoiceSettled && <BrandInfoPanel
          brand={viewModel.brand}
          message={viewModel.message}
          invitationBody={viewModel.invitationBody}
          downloadFileUrl={viewModel.completedFileUrl}
        />}

        {invoiceSettled && <FinishedBrandInfoPanel
          brand={viewModel.brand}
          message={viewModel.message}
          invitationBody={viewModel.invitationBody}
          completedUtc={viewModel.completedUtc}
          docUrl={viewModel.completedFileUrl}
        />}
      </SectionPanel.Section>

      {site.deploymentValues.debug && <DebugPanel viewModel={viewModel} />}

    </TwoColumnLayout.RightColumn>
  </TwoColumnLayout>;
};

const DebugPanel = ({ viewModel }: { viewModel: server.viewmodel.InvoiceV2LandingFrontModel }) => {
  return <Panel
    title={"Debug"}
    panelClassName="s1_related-feature-panel"
  >
    Sent to: <strong>{viewModel.suggestedUserDetails.name.fullName}</strong><br />
    {(viewModel.participant.linkedToUser != null) ? `linked to ${viewModel.participant.linkedToUser.fullName}` : "not linked to user"}

  </Panel >;
};

export default App;
